import { render } from "./LabelBar.vue?vue&type=template&id=6955789e&ts=true"
import script from "./LabelBar.vue?vue&type=script&lang=ts"
export * from "./LabelBar.vue?vue&type=script&lang=ts"

import "./LabelBar.vue?vue&type=style&index=0&id=6955789e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__